import React, { useEffect, useState } from 'react';
import { Card, Col, Form } from 'react-bootstrap';
import { useForm, useWatch } from 'react-hook-form';
import { HttpClient } from '../../../Domain/Utils/ApiUtilies/Fetch/Fetch';
import { recaptchaSiteKey } from '../../../Domain/Settings/Keys/Keys';
import { REGISTER_USER_PATH, API_CODE_VERIFICATION } from '../../../Domain/Redux/Paths';
import { SimpleModalLT } from '../../Modals/SimpleModalLT/SimpleModalLT';
import { InputFormControl } from '../../Atoms/InputFormControl/InputFormControl';
import { SelectFormControl } from '../../Atoms/SelectFormControl/SelectFormControl';
import './PopUpRegisterForm.css';
import { FRONTEND_URL } from '../../../Domain/Redux/Paths';
import Spinner from '../../Atoms/Spinner/Spinner';
import ButtonYellow from '../../Atoms/ButtonYellow/ButtonYellow';
import { UNDEFINED_PLATFORM } from '../../../Domain/Settings/Constants/Constants';
import MessageError from '../../Atoms/MessageError/MessageError';
import AccountVerification from '../AccountVerification/AccountVerification';
import { useGetIdLanguage } from '../../../Core/Hooks/HookLanguageSelector/useGetIdLnaguage';
import { COMPONENTS } from '../../../Domain/Settings/Constants/ComponentsParameter/ComponentsParameter';
import { useCountries } from '../../../Core/Hooks/HookGetCountries/useCountriesList';

// Modal for registering potential customers 2
export const PopUpRegisterForm = ({
  parameters,
  interestData,
  setLoader = () => {},
  afterRegister = () => {},
  colorText = false
}) => {
  const language = useGetIdLanguage();
  const [modalData, setModalData] = useState({
    title: '',
    message: '',
    show: false
  });

  const [labelText, setLabelText] = useState(false);
  const [errorCountry, setErrorCountry] = useState(false);
  const [isActiveModal, setIsActiveModal] = useState(false);
  const [dataForm, setDataForm] = useState({});
  const {
    handleSubmit,
    errors,
    control,
    reset: resetForm,
    watch,
    getValues
  } = useForm({ mode: 'onChange' });
  const nameField = useWatch({
    control,
    name: 'name'
  });
  const emailField = useWatch({
    control,
    name: 'email'
  });

  const platform = sessionStorage.getItem('utm_source');
  const { countriesList, alpha2codeCountries, phoneTypeList } = useCountries();

  useEffect(() => {
    if (nameField || emailField || errors?.name || errors?.email) {
      setLabelText(true);
      return;
    }
    setLabelText(false);
  }, [nameField, emailField, errors]);

  // handle for show / hide the modal
  const closeModal = () => {
    resetForm();
    afterRegister();
    setModalData({
      ...modalData,
      show: false
    });
  };

  // handle submit data
  const onSubmit = () => {
    const values = dataForm;
    window.grecaptcha.ready(() => {
      window.grecaptcha.execute(recaptchaSiteKey, { action: 'homepage' }).then(async (token) => {
        localStorage.setItem('reCaptcha', token);
        const data = {
          name: values.name,
          email: values.email,
          phone_number: values.phone,
          country_code_id: values.phone_code?.pk || values.phone_code?.id || null,
          country_id: values.country.pk,
          phone_type: values.phone_type?.pk || values.phone_type?.id || null,
          information_interest: interestData.name,
          advertising_platform: platform ?? UNDEFINED_PLATFORM,
          component: COMPONENTS.COUNTRY,
          multilanguage_id: language
        };

        try {
          await HttpClient.POST(REGISTER_USER_PATH, data);
          setIsActiveModal(false);
          setModalData({
            title: parameters?.INF_MSG_53?.description_value || 'Información',
            message: parameters?.INF_MSG_53?.value || 'Registro exitoso',
            show: true,
            success: true,
            warning: false
          });
          // resetForm();
          // afterRegister();
          document.getElementsByTagName('html')[0].style.overflowY = 'scroll';
        } catch (error) {
          console.debug('>>>> InterestRegisterForm.onSubmit: error=', error);
          setModalData({
            ...modalData,
            // * parameter code: INF_MSG_54
            title: parameters?.INF_MSG_54?.value || 'Error',
            // * parameter code: INF_MSG_55
            message:
              parameters?.INF_MSG_55?.value ||
              'El registro no se completó debido a un error inesperado. Vuelva a intentarlo más tarde.',
            show: true,
            success: false,
            warning: true
          });
        } finally {
          setLoader(false);
        }
      });
    });
  };

  const sendCodeVerification = async (data) => {
    setErrorCountry(false);
    const country = getValues('country');
    if (!country?.pk) {
      setErrorCountry(true);
      return;
    }
    setDataForm(data);
    setLoader(true);
    const sendCode = await HttpClient.POST(API_CODE_VERIFICATION, {
      email: data.email,
      multilanguageId: language
    });
    if (sendCode?.content) {
      setLoader(false);
      setIsActiveModal(true);
    }
  };
  const selectCommonStyles = {
    option: (styles, { isFocused, isSelected }) => ({
      ...styles,
      backgroundColor: isFocused ? 'rgba(255,255,255,0.1)' : 'transparent',
      color: 'white',
      cursor: 'pointer'
    }),
    control: (styles) => ({
      ...styles,
      backgroundColor: 'transparent',
      color: 'white',
      border: 'none',
      borderBottom: '1px solid white',
      boxShadow: 'none',
      borderRadius: 0
    }),
    singleValue: (styles) => ({
      ...styles,
      color: 'white'
    }),
    input: (styles) => ({
      ...styles,
      color: 'white'
    }),
    placeholder: (styles) => ({
      ...styles,
      color: 'white'
    }),
    menu: (styles) => ({
      ...styles,
      backgroundColor: 'rgba(0, 0, 0, 0.85)',
      zIndex: 5
    }),
    indicatorSeparator: () => ({
      display: 'none'
    }),
    dropdownIndicator: (styles) => ({
      ...styles,
      color: 'white'
    })
  };


  //modal ok change parameters
  return (
    <>
      {modalData.show && (
        <SimpleModalLT
          show={modalData.show}
          title={modalData.message}
          subtitle={modalData.title}
          success={modalData.success}
          warning={modalData.warning}
          closeModal={closeModal}
          bgImage={false}
        />
      )}
      <Card className="border-0 form-body" style={{ borderRadius: '0' }}>
        <Card.Body className="p-0">
          {isActiveModal ? (
            <div style={{ margin: window.innerWidth < 600 ? '0 20px' : '0 60px' }}>
              <AccountVerification
                showTitle
                email={dataForm?.email}
                onCloseModal={setIsActiveModal}
                onFinish={onSubmit}
                colorText={colorText}
              />
            </div>
          ) : (
            <Form className="form-register-interest" onSubmit={handleSubmit(sendCodeVerification)}>
              <div className="px-4 py-2">
                <Form.Group className="mb-0">
                  <InputFormControl
                    name="information_interest"
                    control={control}
                    type="hidden"
                    defaultValue={interestData?.name}
                  />
                </Form.Group>
                <div className="row col-12 d-flex justify-content-end mx-0 px-lg-0">
                  <Col xs={12} lg={5} className="px-0 pe-lg-2">
                    <Form.Group className="my-0">
                      {labelText && (
                        <label
                          className="description-label"
                          style={{ color: '#fff' }}
                          htmlFor="name"
                          // * parameter code: PH_MSG_1
                        >
                          {parameters?.PH_MSG_1?.value || (
                            <Spinner backgroundColor="white"></Spinner>
                          )}
                        </label>
                      )}
                      {parameters?.PH_MSG_1?.value ? (
                        <InputFormControl
                          name="name"
                          control={control}
                          type="text"
                          // * parameter code: PH_MSG_1
                          rules={{
                            required: parameters?.RQD_MSG_1?.value || (
                              <Spinner backgroundColor="black"></Spinner>
                            )
                          }}
                          placeholder={parameters?.PH_MSG_1?.value}
                          error={errors?.name}
                        />
                      ) : (
                        <p>
                          <Spinner backgroundColor="white"></Spinner>
                        </p>
                      )}
                    </Form.Group>
                  </Col>
                  <Col xs={12} lg={7} className="px-0 ps-lg-2">
                    <Form.Group className="my-0">
                      {labelText && (
                        <label
                          className="description-label"
                          style={{ color: '#fff' }}
                          htmlFor="email"
                          // * parameter code: PH_MSG_2
                        >
                          {parameters?.PH_MSG_2?.value || <Spinner backgroundColor="white" />}
                        </label>
                      )}
                      {parameters?.PH_MSG_2?.value ? (
                        <InputFormControl
                          name="email"
                          control={control}
                          type="email"
                          rules={{
                            // * parameter code: RQD_MSG_2
                            required: parameters?.RQD_MSG_2?.value || (
                              <Spinner backgroundColor="white" />
                            ),
                            pattern: {
                              value:
                                /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
                              // * parameter code: ERR_MSG_2
                              message: parameters?.ERR_MSG_2?.value || (
                                <Spinner backgroundColor="white" />
                              )
                            }
                          }}
                          // * parameter code: PH_MSG_2
                          placeholder={parameters?.PH_MSG_2?.value}
                          error={errors?.email}
                          textColor={'black'}
                        />
                      ) : (
                        <p>
                          <Spinner backgroundColor="white"></Spinner>
                        </p>
                      )}
                    </Form.Group>
                  </Col>
                </div>
                {/* <div className='justify-content-center' ></div> */}
                <Form.Group className="my-0 mt-2">
                  <div className="row" style={{ alignItems: 'flex-end' }}>
                    <Col xs={6} lg={5} className="pe-2">
                      {parameters?.PH_MSG_3?.value ? (
                        <SelectFormControl
                          name="phone_code"
                          control={control}
                          defaultValue={{
                            flag: 'https://static.litethinking.com/static/flag_country/co.png',
                            value: 'Colombia',
                            abbreviation_name: 'co',
                            dial_code: '+57',
                            pk: 35
                          }}
                          options={alpha2codeCountries}
                          nameOptionValue="abbreviation_name"
                          // * parameter code: RQD_MSG_3
                          rules={{
                            required: parameters?.RQD_MSG_3?.value || 'El campo es requerido.'
                          }}
                          error={errors?.dial_code}
                          renderOptionLabel={(option) => (
                            <>
                              <img
                                src={`${option?.flag}`}
                                alt="Country flag"
                                style={{ width: 20, marginRight: 5 }}
                              />
                              {`${option?.abbreviation_name} ${option?.dial_code}`.toUpperCase()}
                            </>
                            
                          )}
                          // * parameter code: PH_MSG_3
                          placeholder={
                            <span style={{ color: 'white' }}>{parameters?.PH_MSG_3?.value}</span>
                          }
                          selectStyles={selectCommonStyles} // ← APLICACIÓN ESPECÍFICA
                        />
                      ) : (
                        <Spinner backgroundColor="white"></Spinner>
                      )}
                    </Col>
                    <Col xs={6} lg={7} className="ps-2">
                      {watch('phone')?.length > 0 && (
                        <label
                          className="description-label"
                          style={{ color: '#fff' }}
                          htmlFor="phone"
                          // * parameter code: PH_MSG_5
                        >
                          {parameters?.PH_MSG_5?.value || 'Número móvil *'}
                        </label>
                      )}
                      {parameters?.PH_MSG_5?.value ? (
                        <InputFormControl
                          name="phone"
                          control={control}
                          type="number"
                          rules={{
                            // * parameter code: RQD_MSG_3
                            required: parameters?.RQD_MSG_3?.value || 'El campo es requerido',
                            pattern: {
                              value: /^[0-9]+$/,
                              // * parameter code: ERR_MSG_3
                              message: parameters?.ERR_MSG_3?.value || 'Únicamente números'
                            }
                          }}
                          // * parameter code: PH_MSG_5
                          placeholder={parameters?.PH_MSG_5?.value}
                          error={errors?.phone}
                          selectStyles={selectCommonStyles} // ← APLICACIÓN ESPECÍFICA
                        />
                      ) : (
                        <Spinner backgroundColor="white"></Spinner>
                      )}
                    </Col>
                  </div>
                </Form.Group>
                <Form.Group className="my-0 mt-2">
                  {watch('phone_type') && (
                    <label className="description-label" style={{ color: '#fff' }}htmlFor="phone_type">
                      {parameters?.PHONE_TYPE_LABEL?.value || <Spinner backgroundColor="black"></Spinner>}
                    </label>
                  )}
                  {parameters?.PHONE_TYPE_LABEL?.value ? (
                    <SelectFormControl
                      ariaLabel={parameters?.PHONE_TYPE_LABEL?.value || 'Número móvil *'}
                      name="phone_type"
                      control={control}
                      options={phoneTypeList}
                      nameOptionValue="name"
                      rules={{
                        required: parameters?.PHONE_TYPE_LABEL?.value || (
                          <Spinner backgroundColor="white"></Spinner>
                        )
                      }}
                      error={errors?.country}
                      renderOptionLabel={(option) => option.name}
                      placeholder={
                        <span style={{ color: 'white' }}>{parameters?.PHONE_TYPE_LABEL?.value}</span>
                      }
                      selectStyles={selectCommonStyles} // ← APLICACIÓN ESPECÍFICA
                    />
                  ) : (
                    <p>
                      <Spinner backgroundColor="white"></Spinner>
                    </p>
                  )}
                  {errorCountry && <MessageError message={parameters?.RQD_MSG_3?.value} />}
                </Form.Group>
                <Form.Group className="my-0 mt-2">
                  {watch('country') && (
                    <label className="description-label" style={{ color: '#fff' }}htmlFor="country">
                      {parameters?.PH_MSG_6?.value || <Spinner backgroundColor="black"></Spinner>}
                    </label>
                  )}
                  {parameters?.PH_MSG_7?.value ? (
                    <SelectFormControl
                      ariaLabel="Select your country"
                      name="country"
                      control={control}
                      options={countriesList}
                      nameOptionValue="name"
                      rules={{
                        required: parameters?.RQD_MSG_3?.value || (
                          <Spinner backgroundColor="white"></Spinner>
                        )
                      }}
                      error={errors?.country}
                      renderOptionLabel={(option) => option.name}
                      placeholder={
                        <span style={{ color: 'white' }}>{parameters?.PH_MSG_7?.value}</span>
                      }
                      selectStyles={selectCommonStyles} // ← APLICACIÓN ESPECÍFICA
                    />
                  ) : (
                    <p>
                      <Spinner backgroundColor="white"></Spinner>
                    </p>
                  )}
                  {errorCountry && <MessageError message={parameters?.RQD_MSG_3?.value} />}
                </Form.Group>

                <div className="d-grid justify-content-center mt-3">
                  <ButtonYellow
                    disabled={Object.values(errors).length}
                    style={{ borderRadius: '5px', minHeight: '60px', minWidth: '200px' }}
                    title={
                      parameters?.INF_MSG_60?.value || <Spinner backgroundColor="black"></Spinner>
                    }
                  />
                </div>
                <p
                  style={{
                    textAlign: 'center',
                    width: '100%',
                    marginTop: '1rem',
                    fontSize: '16px'
                    // * parameter code: INF_MSG_3
                  }}>
                  {parameters?.INF_MSG_3?.value?.split('-')[0] || ''}
                  <a
                    title="Términos de uso"
                    aria-label="Terminos de uso"
                    style={{ color: 'white', fontWeight: 'bold', textDecoration: 'none' }}
                    href={`${FRONTEND_URL}/policies-of-usage`}>
                    {parameters?.INF_MSG_3?.value?.split('-')[1] || ''}
                  </a>{' '}
                  {parameters?.INF_MSG_3?.value?.split('-')[2] || ''}
                  <a
                    title="Política de privacidad"
                    aria-label="Politica de privacidad"
                    style={{ color: 'white', fontWeight: 'bold', textDecoration: 'none' }}
                    href={`${FRONTEND_URL}/privacity-policies`}>
                    {parameters?.INF_MSG_3?.value?.split('-')[3] || ''}
                  </a>{' '}
                  {parameters?.INF_MSG_3?.value?.split('-')[4] || ''}
                </p>
                {/* <p
                style={{ textAlign: 'center', width: '100%', fontSize: '16px' }}
                // * parameter code: INF_MSG_59
              >
                {parameters?.INF_MSG_59?.value || <Spinner backgroundColor="white"></Spinner>}
              </p> */}
              </div>
            </Form>
          )}
        </Card.Body>
      </Card>
    </>
  );
};
